export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  { text: 'Mã NS', align: 'start', value: 'keyEmployeeCode', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'keyEmployeeCode')?.value) return true
        return value.includes(filters.find(x=>x.name === 'keyEmployeeCode')?.value)
      }
  },
  { text: 'Tên NS', align: 'start', value: 'keyEmployeeName', width: '10rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'keyEmployeeName')?.value) return true
        return value.includes(filters.find(x=>x.name === 'keyEmployeeName')?.value)
      }
  },

  { text: 'Phân loại', align: 'start', value: 'keyType',
      filter: value => true
  },
  
  { text: 'Tháng 1', align: 'start', value: 'month1',
      filter: value => true
  },
  
  { text: 'Tháng 2', align: 'start', value: 'month2',
      filter: value => true
  },

  { text: 'Tháng 3', align: 'start', value: 'month3',
      filter: value => true
  },
  { text: 'Điểm NVM', align: 'start', value: 'totalScoreNvm',
      filter: value => true
  },
  { text: 'Tổng điểm NVM', align: 'start', value: 'totalMaxScoreNvm',
      filter: value => true
  },
  { text: 'Tháng 4', align: 'start', value: 'month4',
      filter: value => true
  },
  
  { text: 'Tháng 5', align: 'start', value: 'month5',
      filter: value => true
  },
  
  { text: 'Tháng 6', align: 'start', value: 'month6',
      filter: value => true
  },
  { text: 'Điểm COT2', align: 'start', value: 'totalScoreCot2',
      filter: value => true
  },
  { text: 'Tổng điểm COT2', align: 'start', value: 'totalMaxScoreCot2',
      filter: value => true
  },
]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Điều kiện', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]